<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'sm'"
    :modal-id="'reward-modal'"
    @hidden="$bvModal.hide('reward-modal')"
    @show="() => {}"
  >
    <b-form @submit.prevent="onSubmitModal">
      <div class="row mb-1">
        <div class="col-12 p-0">
          <div class="information-header font-weight-bolder text-black">
            Edit Reward Name
          </div>
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-12 pl-3 pr-3">
          <div class="row mb-1 mt-2">
            <div class="col-12">
              <b-form-group
                :label="'Reward Name (Thai) '"
                label-for="rewardName"
                label-class="font-medium-5 required"
              >
                <b-form-input
                  id="rewardName"
                  v-model="formDataObj.reward.title"
                  :placeholder="'ระบุ'"
                  required
                />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                :btnLabel="'Back'"
                :stageBack="true"
                @click.native="$emit('onCloseModal')"
              />
              <save-button class="ml-1" type="submit" />
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import { reactive, getCurrentInstance } from "@vue/composition-api";

export default {
  props: {
    isEdit: { type: Boolean, default: false },
    formDataObj: { type: [Object, Array], default: null },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const onSubmitModal = () => {
      vm.$emit("onSubmitRewardModal");
    };

    return { onSubmitModal };
  },
};
</script>

<style>
.modal .modal-header {
  display: none;
}

.modal-content {
  border-radius: 1.6rem;
}
</style>

<style scoped>
#reward-modal .information-header {
  border-bottom: 1px solid #ececec;
  padding: 5px 15px 10px;
  font-size: 1.8rem !important;
  width: 100%;
}

.font-Information {
  font-size: 1.8rem;
}
</style>